import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './base.service';
import { AuthService } from './auth.service';
import { Data } from '../providers/data';

@Injectable()
export class AfiliadoService {
  constructor(
    public http: HttpClient,
    public serviceBase: ServiceBase,
    public authService: AuthService,
    public data: Data
  ) {}

  get(tipoDoc, doc): any {
    const urlService = this.serviceBase.getUrlApi('v1/affiliate');
    return this.http.get<any>(`${urlService}status/${tipoDoc}/${doc}`)
    .pipe(
      map((response) => response ),
      catchError(this.serviceBase.handleError)
    );
  }

  validateBenefit(params): any{
    const urlService = this.serviceBase.getUrlApi('v1/benefit/validate');
    const req = {
      affiliate: {
        credential: {
          number: params.credencial,
        } ,
        identification: {
          number: params.documentoAfiliado,
          type: params.tipoDocumentoAfiliado
        },
        authorizationToken: params.token,
      },
      practices: params.practicas,
      isEmergency: params.emergencia,
      doctor: {
        name: params.nyaMedico,
        license: params.matricula,
        licenseType: '',
        identificationId: params.documento,
        cuitNumber: '',
      },
    };

    return this.http
      .post<any>(urlService, req, this.serviceBase.postCommonHeaders())
      .pipe(
        map((response) => response),
        catchError(this.serviceBase.handleError)
      );
  }

 downloadTicket(orderId, orderPracticeId): any {
  return this.http.get(`${this.serviceBase.getUrlApi('v1/order/ticket/practice')}${orderId}/${orderPracticeId}`, {
    responseType: 'blob'
  })
  .pipe(
    map((res) => res),
    catchError(this.serviceBase.handleError)
  );
  }

  createBenefit(params): any {
    const urlService = this.serviceBase.getUrlApi('v1/benefit/create');
    const req = {
      affiliate: {
        credential: {
          number: params.credencial,
        } ,
        identification: {
          number: params.documentoAfiliado,
          type: params.tipoDocumentoAfiliado
        },
        authorizationToken: params.token,
      },
      practices: params.practicas,
      isEmergency: params.emergencia,
      doctor: {
        name: params.nyaMedico,
        license: params.matricula,
        licenseType: '',
        identificationId: params.documento,
        cuitNumber: '',
      },
    };

    return this.http
      .post<any>(urlService, req, this.serviceBase.postCommonHeaders())
      .pipe(
        map((response) => response),
        catchError(this.serviceBase.handleError)
      );
  }
}
